import { Stack } from '@atgfr8/atg-ui-tailwind';
import { BasicModal, Notification } from '@components';
import { flagImgs } from '@components/FlagPopup/constants';
import { closeModal, openModal } from '@store/modals';
import { userStore } from '@store/user';
import { FlagViewModel } from '@typeDefinitions/flagTypes';
import { IOrderViewModel } from '@typeDefinitions/orderTypes';
import { convertUtcToLocalAndFormat } from '@utils/dateFormat';
import EditBillingNotesModal from '@views/order/components/models/EditBillingHoldAndNotesModal';
import { EDIT_BILLING_HOLD_AND_NOTE } from '@views/order/constants';
import { get, isEmpty } from 'lodash';
import { Accessor, Index, Show, createSignal } from 'solid-js';

import classes from './classes';

const modalStyles = { maxWidth: '90vw', background: 'white' };

type SelectedFlagType = {
  item: FlagViewModel | null;
  index: number | null;
};

type BillingHoldFlagProps = {
  flags: FlagViewModel[];
  updateFlags: (flags: FlagViewModel[] | Partial<IOrderViewModel>) => void;
  orderId: number;
};
const BillingHoldFlagV2 = (props: BillingHoldFlagProps) => {
  const [selectedFlag, setSelectedFlag] = createSignal<SelectedFlagType>({
    item: null,
    index: null,
  });

  const flagNotificationTextContent = (item: Accessor<FlagViewModel>) => {
    return (
      <div class={classes.noteContainer}>
        <strong>{item().flagType} </strong>
        <span>- </span>
        <span>{item().description}</span>
      </div>
    );
  };

  const flagNotificationSubTextContent = (item: Accessor<FlagViewModel>) => {
    return (
      <div>
        <span>
          {/* // check in v3 edit res setBy is coming null */}
          {!isEmpty(get(item(), 'setBy'))
            ? item().setBy
            : userStore.user.name}{' '}
        </span>
        <span>- </span>
        <span>
          {convertUtcToLocalAndFormat(
            item().setDate as string,
            'MMM dd, yyyy h:mm a',
          )}
        </span>
      </div>
    );
  };

  const editFlag = (item: FlagViewModel, index: number) => {
    setSelectedFlag({
      item,
      index,
    });
    openModal(EDIT_BILLING_HOLD_AND_NOTE);
  };

  return (
    <Show when={props.flags}>
      <Stack spacing={2} class="my-2">
        <Index each={props.flags}>
          {(item: Accessor<FlagViewModel>, index: number) => (
            <Notification
              type={item().flagType}
              text={flagNotificationTextContent(item)}
              subText={flagNotificationSubTextContent(item)}
              onClick={() => editFlag(item(), index)}
              imgIcon={flagImgs[item().flagType]}
            />
          )}
        </Index>
      </Stack>
      <BasicModal
        id={EDIT_BILLING_HOLD_AND_NOTE}
        width="800px"
        modalStyles={modalStyles}
        header={false}
        footer={false}
        showClose={false}
        onClose={() => {
          setSelectedFlag({ item: null, index: null });
          closeModal(EDIT_BILLING_HOLD_AND_NOTE);
        }}
      >
        <Show when={selectedFlag().item}>
          <EditBillingNotesModal
            modalId={EDIT_BILLING_HOLD_AND_NOTE}
            item={selectedFlag().item as FlagViewModel}
            index={selectedFlag().index!}
            flags={props.flags}
            updateFlags={props.updateFlags}
          />
        </Show>
      </BasicModal>
      {/* I don't think we need this modal over here. It also interferes with the one in MoreOptions */}
      {/* <BasicModal
        id={ADD_BILLING_HOLD_NOTE}
        width="900px"
        modalStyles={modalStyles}
        header={false}
        footer={false}
        showClose={false}
      >
        <BillingHoldModal
          modalId={ADD_BILLING_HOLD_NOTE}
          flags={props.flags}
          updateFlags={props.updateFlags}
        />
      </BasicModal> */}
    </Show>
  );
};

export default BillingHoldFlagV2;
